import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/navigation/Navbar';
import Footer from './components/layout/Footer';
import AppRoutes from './routes/AppRoutes';
import MobileCtaBar from './components/mobile/MobileCtaBar';
import { useIsMobile } from './utils/useIsMobile';

const App: React.FC = () => {
  const mobile = useIsMobile();
  return (
    <Router>
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Navbar />
        <main style={{ flexGrow: 1, paddingBottom: mobile ? 'calc(76px + env(safe-area-inset-bottom, 0px))' : 0 }}>
          <AppRoutes />
        </main>
        <Footer />
        <MobileCtaBar />
      </div>
    </Router>
  );
};

export default App;
